<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';

import useStorageStore from '@/stores/storage';

const { initStorage } = useStorageStore();
onMounted(() => {
  initStorage();
});
</script>

<template>
  <a-config-provider :locale="zhCN">
    <RouterView />
  </a-config-provider>
</template>
